"use strict";

exports.__esModule = true;
exports.showCheck10a = exports.clickCheck10aOtherAccount = exports.clickCheck10aModify = exports.clickCheck10aClose = void 0;

var _constants = require("../constants");

const eventLabel = (offer, type) => ({
  eventlabel: `subscriptionshop/order?typeproduct=${offer}&typeflow=${type}`
});

const showCheck10a = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.showOverlay,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCheck10a = showCheck10a;

const clickCheck10aClose = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.clickClose,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck10aClose = clickCheck10aClose;

const clickCheck10aModify = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.clickConfirm,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck10aModify = clickCheck10aModify;

const clickCheck10aOtherAccount = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.conversionWall,
  eventaction: `click-other-account`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck10aOtherAccount = clickCheck10aOtherAccount;